(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pl", [], factory);
	else if(typeof exports === 'object')
		exports["pl"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["pl"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 